(function () {
  const API_BASE = window.CAR_CONFIG_API_BASE;
  const root = document.getElementById("car-config");
  if (!API_BASE || !root) return;

  const qs = new URLSearchParams(location.search);

  const steps = [
    { key: "make" },
    { key: "model" },
    { key: "complectation" },
    { key: "year" },
    { key: "body_type" },
    { key: "doors" },
    { key: "engine" },
    { key: "transmission" },
    { key: "drive" },
  ];

  const STORAGE_KEY = "car_config_preset_v1";

  const els = {
    progressBar: document.getElementById("cc_progress_bar"),
    progressText: document.getElementById("cc_progress_text"),
    resetBtn: document.getElementById("cc_reset"),

    prop_make: document.getElementById("prop_make"),
    prop_model: document.getElementById("prop_model"),
    prop_complectation: document.getElementById("prop_complectation"),
    prop_year: document.getElementById("prop_year"),
    prop_body_type: document.getElementById("prop_body_type"),
    prop_doors: document.getElementById("prop_doors"),
    prop_engine: document.getElementById("prop_engine"),
    prop_transmission: document.getElementById("prop_transmission"),
    prop_drive: document.getElementById("prop_drive"),
    prop_car_id: document.getElementById("prop_car_id"),
    prop_mod_id: document.getElementById("prop_mod_id"),
    prop_art_id: document.getElementById("prop_art_id"),
    prop_checkout_car: document.getElementById("prop_checkout_car"),
    prop_checkout_year: document.getElementById("prop_checkout_year"),
    prop_checkout_drive: document.getElementById("prop_checkout_drive"),
    prop_checkout_transmission: document.getElementById("prop_checkout_transmission"),
    prop_checkout_engine: document.getElementById("prop_checkout_engine"),
  };

  const state = {
    itemsByKey: {},
    openKey: null,
    addBtn: null,
    guarding: false,
    observer: null,
    isBootstrapped: false,
  };

  // -------------------------
  // Core helpers
  // -------------------------
  function setStatus(msg) {
    return msg;
  }

  function firstIncompleteKey() {
    for (const s of steps) {
      if (!qs.get(s.key)) return s.key;
    }
    return null;
  }

  function setUrlParam(key, val) {
    if (!val) qs.delete(key);
    else qs.set(key, String(val));
    history.replaceState({}, "", `${location.pathname}?${qs.toString()}`);
  }
  
  function saveStateToStorage() {
  const data = {};
  steps.forEach(s => {
    const v = qs.get(s.key);
    if (v) data[s.key] = v;
  });
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function loadStateFromStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
}

  function getFiltersUntil(idxInclusive) {
    const filters = {};
    for (let i = 0; i <= idxInclusive; i++) {
      const k = steps[i].key;
      const v = qs.get(k);
      if (v) filters[k] = v;
    }
    return filters;
  }

  function updateStepValue(key) {
    const el = root.querySelector(`[data-value="${key}"]`);
    if (!el) return;
    const v = qs.get(key) || "";
    if (v) {
      el.textContent = v;
      el.classList.remove("is-empty");
    } else {
      el.textContent = "wybierz";
      el.classList.add("is-empty");
    }
  }

  function setStepEnabled(key, enabled) {
    const row = root.querySelector(`[data-row="${key}"]`);
    if (!row) return;
    row.classList.toggle("cc-disabled", !enabled);
  }

  function setMenuOpen(key, open) {
    const menu = root.querySelector(`[data-menu="${key}"]`);
    const row = root.querySelector(`[data-row="${key}"]`);
    if (!menu || !row) return;
    menu.hidden = !open;
    row.classList.toggle("is-open", open);
    if (open) {
      const search = root.querySelector(`[data-search="${key}"]`);
      if (search) search.focus();
    }
  }

  function closeAllMenus() {
    steps.forEach((s) => setMenuOpen(s.key, false));
    state.openKey = null;
  }

  function openStep(key) {
    const idx = steps.findIndex((s) => s.key === key);
    if (idx === -1) return;

    // если предыдущий шаг не выбран — открываем предыдущий
    if (idx > 0 && !qs.get(steps[idx - 1].key)) key = steps[idx - 1].key;

    closeAllMenus();
    state.openKey = key;
    setMenuOpen(key, true);

    if (!state.itemsByKey[key] || state.itemsByKey[key].length === 0) {
      loadOptionsFor(key).catch(() => {});
    } else {
      const search = root.querySelector(`[data-search="${key}"]`);
      renderList(key, search ? search.value : "");
    }
  }

  function scrollToStep(key) {
    const row = root.querySelector(`[data-row="${key}"]`);
    if (!row) return;
    row.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function clearResolveProps() {
    if (els.prop_car_id) els.prop_car_id.value = "";
    if (els.prop_mod_id) els.prop_mod_id.value = "";
    if (els.prop_art_id) els.prop_art_id.value = "";
  }

  function syncCheckoutSummaryProps() {
    const make = qs.get("make") || "";
    const model = qs.get("model") || "";
    const complectationRaw = qs.get("complectation") || "";
    const complectation = complectationRaw === "Nie dotyczy" ? "" : complectationRaw;
    const year = qs.get("year") || "";
    const engine = qs.get("engine") || "";
    const transmission = qs.get("transmission") || "";
    const drive = qs.get("drive") || "";

    let heading = [make, model, complectation].filter(Boolean).join(" ").trim();

    if (els.prop_checkout_car) els.prop_checkout_car.value = heading;
    if (els.prop_checkout_year) els.prop_checkout_year.value = year;
    if (els.prop_checkout_drive) els.prop_checkout_drive.value = drive;
    if (els.prop_checkout_transmission) els.prop_checkout_transmission.value = transmission;
    if (els.prop_checkout_engine) els.prop_checkout_engine.value = engine;
  }

  function syncProps() {
    if (els.prop_make) els.prop_make.value = qs.get("make") || "";
    if (els.prop_model) els.prop_model.value = qs.get("model") || "";
    if (els.prop_complectation) els.prop_complectation.value = qs.get("complectation") || "";
    if (els.prop_year) els.prop_year.value = qs.get("year") || "";
    if (els.prop_body_type) els.prop_body_type.value = qs.get("body_type") || "";
    if (els.prop_doors) els.prop_doors.value = qs.get("doors") || "";
    if (els.prop_engine) els.prop_engine.value = qs.get("engine") || "";
    if (els.prop_transmission) els.prop_transmission.value = qs.get("transmission") || "";
    if (els.prop_drive) els.prop_drive.value = qs.get("drive") || "";
    syncCheckoutSummaryProps();
  }

  // -------------------------
  // IMPORTANT: instant Add-to-cart disabling (no waiting for API)
  // -------------------------
  function applyAddBtnState() {
    if (!state.addBtn) return;

    // СРАЗУ блокируем, пока не выбраны все шаги. Никаких mod_id и API.
    const incomplete = !!firstIncompleteKey();

    state.addBtn.disabled = incomplete;
    state.addBtn.setAttribute("aria-disabled", String(incomplete));
    state.addBtn.style.opacity = incomplete ? "0.6" : "";
    state.addBtn.style.cursor = incomplete ? "not-allowed" : "";
  }
function ensurePropertiesInForm() {
  const form =
    root.closest('form[action^="/cart/add"]') ||
    document.querySelector('form[action^="/cart/add"]');

  if (!form) return;

  // все inputs properties внутри #car-config
  const inputs = root.querySelectorAll('input[name^="properties["]');
  inputs.forEach((inp) => {
    // если уже внутри формы — ок
    if (form.contains(inp)) return;
    // перемещаем внутрь формы (лучше в конец)
    form.appendChild(inp);
  });
}

  function findAddToCartButton() {
    const form =
      root.closest('form[action^="/cart/add"]') ||
      root.closest("form") ||
      document.querySelector('form[action^="/cart/add"]');

    if (!form) return null;

    return (
      form.querySelector('button[type="submit"]') ||
      form.querySelector('button[name="add"]') ||
      form.querySelector('[ref="addToCartButton"]') ||
      form.querySelector('add-to-cart-component button') ||
      form.querySelector('product-form-component button[type="submit"]')
    );
  }

  function bindAddToCartGuard(btn) {
    // CAPTURE handler: блокируем тему ДО её JS
    const handler = async (ev) => {
      if (state.guarding) return;
      state.guarding = true;

      try {
        const missing = firstIncompleteKey();
        if (missing) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

          setStatus("Uzupełnij wybór auta.");
          openStep(missing);
          scrollToStep(missing);
          return;
        }

        // Все шаги выбраны → только тут (по клику) проверяем mod_id через resolve
        setStatus("Sprawdzanie dopasowania…");
        await resolveIfComplete();

        if (!els.prop_mod_id || !els.prop_mod_id.value) {
          ev.preventDefault();
          ev.stopPropagation();
          if (ev.stopImmediatePropagation) ev.stopImmediatePropagation();

          setStatus("Brak dopasowania (mod_id). Sprawdź wybór.");
          openStep("make");
          scrollToStep("make");
          return;
        }

        // всё ок — не мешаем добавлению
      } finally {
        state.guarding = false;
      }
    };

    btn.addEventListener("click", handler, true);
    btn.addEventListener("pointerup", handler, true);
  }

  function setupAddToCartObserver() {
    ensurePropertiesInForm();

    // 1) попытка сразу
    const btnNow = findAddToCartButton();
    if (btnNow) {
      state.addBtn = btnNow;
      bindAddToCartGuard(btnNow);
      applyAddBtnState(); // <-- мгновенно
      return;
    }

    // 2) если кнопка появляется позже (Horizon часто так делает) — ловим через observer
    state.observer = new MutationObserver(() => {
      const btn = findAddToCartButton();
      if (!btn) return;

      state.addBtn = btn;
      bindAddToCartGuard(btn);
      applyAddBtnState(); // <-- мгновенно как только нашли кнопку

      // можно отключить observer
      if (state.observer) {
        state.observer.disconnect();
        state.observer = null;
      }
    });

    state.observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // -------------------------
  // Progress UI
  // -------------------------
  function updateDotsAndProgress() {
    let doneCount = 0;

    steps.forEach((s, i) => {
      const hasVal = !!qs.get(s.key);
      if (hasVal) doneCount = i + 1;

      const dot = root.querySelector(`[data-dot="${s.key}"]`);
      if (dot) {
        dot.classList.toggle("is-done", hasVal);
        dot.classList.toggle("is-active", !hasVal && i === doneCount);
      }

      updateStepValue(s.key);
    });

    const total = steps.length;
    const currentStep = Math.min(doneCount + 1, total);

    if (els.progressText) els.progressText.textContent = `Krok ${currentStep}/${total}`;
    if (els.progressBar) {
      const pct = Math.round((doneCount / total) * 100);
      els.progressBar.style.width = `${pct}%`;
    }

    steps.forEach((s, i) => {
      if (i === 0) return setStepEnabled(s.key, true);
      const prevFilled = !!qs.get(steps[i - 1].key);
      setStepEnabled(s.key, prevFilled);
    });

    // <-- самое важное: обновляем кнопку без ожидания API
    applyAddBtnState();
  }

  // -------------------------
  // API
  // -------------------------
  async function apiOptions(field, filters) {
    const u = new URL(API_BASE);
    u.searchParams.set("action", "options");
    u.searchParams.set("field", field);
    Object.entries(filters || {}).forEach(([k, v]) => u.searchParams.set(k, v));
    const res = await fetch(u.toString(), { method: "GET" });
    if (!res.ok) throw new Error("API options failed");
    return await res.json();
  }

  async function apiResolve(allFilters) {
    const u = new URL(API_BASE);
    u.searchParams.set("action", "resolve");
    Object.entries(allFilters || {}).forEach(([k, v]) => u.searchParams.set(k, v));
    const res = await fetch(u.toString(), { method: "GET" });
    if (!res.ok) throw new Error("API resolve failed");
    return await res.json();
  }

  // -------------------------
  // Dropdown rendering
  // -------------------------
  function renderList(key, filterText) {
    const list = root.querySelector(`[data-list="${key}"]`);
    if (!list) return;

    const items = state.itemsByKey[key] || [];
    const q = (filterText || "").trim().toLowerCase();
    const selected = qs.get(key) || "";

    const filtered = q
      ? items.filter((it) => (it.label || it.value || "").toLowerCase().includes(q))
      : items;

    list.innerHTML = "";

    if (!filtered.length) {
      const div = document.createElement("div");
      div.className = "cc-item";
      div.style.opacity = ".6";
      div.textContent = "Brak opcji";
      list.appendChild(div);
      return;
    }

    filtered.forEach((it) => {
      const div = document.createElement("div");
      div.className = "cc-item" + (it.value === selected ? " is-selected" : "");
      div.textContent = it.label;

      div.addEventListener("click", () => {
        onSelectValue(key, it.value).catch(console.error);
      });

      list.appendChild(div);
    });
  }

  function resetFrom(index) {
    for (let i = index; i < steps.length; i++) {
      const k = steps[i].key;
      qs.delete(k);
      state.itemsByKey[k] = [];

      const search = root.querySelector(`[data-search="${k}"]`);
      if (search) search.value = "";

      const list = root.querySelector(`[data-list="${k}"]`);
      if (list) list.innerHTML = "";

      updateStepValue(k);
    }

    clearResolveProps();
    history.replaceState({}, "", `${location.pathname}?${qs.toString()}`);
    syncProps();
    updateDotsAndProgress();
  }

  async function loadOptionsFor(key) {
    const idx = steps.findIndex((s) => s.key === key);
    const filters = idx === 0 ? {} : getFiltersUntil(idx - 1);

    setStatus("Ładowanie…");
    const items = await apiOptions(key, filters);
    state.itemsByKey[key] = Array.isArray(items) ? items : [];
    setStatus("");

    const search = root.querySelector(`[data-search="${key}"]`);
    renderList(key, search ? search.value : "");
  }

  function getSingleOptionValue(key) {
    const items = state.itemsByKey[key] || [];
    if (items.length !== 1) return "";
    const only = items[0];
    return only && only.value ? String(only.value) : "";
  }

  async function advanceFromStepIndex(startIndex) {
    for (let idx = startIndex; idx < steps.length; idx++) {
      const key = steps[idx].key;

      await loadOptionsFor(key);

      const singleValue = getSingleOptionValue(key);
      if (!singleValue) {
        state.openKey = key;
        setMenuOpen(key, true);
        return;
      }

      if (qs.get(key) !== singleValue) {
        setUrlParam(key, singleValue);
        resetFrom(idx + 1);
        closeAllMenus();
        syncProps();
        updateDotsAndProgress();
      }
    }

    closeAllMenus();
    await resolveIfComplete().catch(() => {});
    updateDotsAndProgress();
  }

  async function onSelectValue(key, value) {
    const idx = steps.findIndex((s) => s.key === key);

    setUrlParam(key, value);
    saveStateToStorage();

    // сброс следующих
    resetFrom(idx + 1);

    closeAllMenus();
    syncProps();
    updateDotsAndProgress(); // <-- кнопка обновляется сразу

    // грузим следующий и открываем
    if (idx + 1 < steps.length) {
      await advanceFromStepIndex(idx + 1);
      return;
    }

    await resolveIfComplete().catch(() => {});
  }

  async function resolveIfComplete() {
    const all = {};
    for (const s of steps) {
      const v = qs.get(s.key);
      if (!v) {
        clearResolveProps();
        return;
      }
      all[s.key] = v;
    }

    const out = await apiResolve(all);

    if (out && out.count === 1 && out.matches && out.matches[0]) {
      const row = out.matches[0];
      if (els.prop_car_id) els.prop_car_id.value = row.car_id || "";
      if (els.prop_mod_id) els.prop_mod_id.value = row.mod_id || "";
      if (els.prop_art_id) els.prop_art_id.value = row.art_id || "";
    } else {
      clearResolveProps();
    }
  }

  // -------------------------
  // UI wiring
  // -------------------------
  function wireUI() {
    // open step
    root.querySelectorAll("[data-toggle]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const key = btn.getAttribute("data-toggle");
        const idx = steps.findIndex((s) => s.key === key);
        if (idx > 0 && !qs.get(steps[idx - 1].key)) return;

        const willOpen = state.openKey !== key;
        closeAllMenus();
        if (!willOpen) return;

        state.openKey = key;
        setMenuOpen(key, true);

        if (!state.itemsByKey[key] || state.itemsByKey[key].length === 0) {
          advanceFromStepIndex(idx).catch(() => {});
        } else {
          const search = root.querySelector(`[data-search="${key}"]`);
          renderList(key, search ? search.value : "");
        }
  
      });
      document.querySelectorAll(".cc-set-option").forEach(el => {
  el.addEventListener("click", () => {
    const set = el.dataset.set;

    window.dispatchEvent(new CustomEvent("cc:set-change", {
      detail: set
    }));
  });
});
    });

    // search filter
    steps.forEach((s) => {
      const search = root.querySelector(`[data-search="${s.key}"]`);
      if (!search) return;
      search.addEventListener("input", () => renderList(s.key, search.value));
    });

    // click outside closes
    document.addEventListener("click", (e) => {
      if (!root.contains(e.target)) closeAllMenus();
    });

    // reset
    if (els.resetBtn) {
      els.resetBtn.addEventListener("click", () => {
        closeAllMenus();
        localStorage.removeItem(STORAGE_KEY);
        steps.forEach((s) => qs.delete(s.key));
        history.replaceState({}, "", `${location.pathname}?${qs.toString()}`);

        state.itemsByKey = {};
        state.openKey = null;

        steps.forEach((s) => {
          const search = root.querySelector(`[data-search="${s.key}"]`);
          if (search) search.value = "";
          const list = root.querySelector(`[data-list="${s.key}"]`);
          if (list) list.innerHTML = "";
          updateStepValue(s.key);
        });

        syncProps();
        clearResolveProps();
        setStatus("");

        updateDotsAndProgress(); // <-- кнопка отключится мгновенно

        // грузим make в фоне
        advanceFromStepIndex(0).catch(() => {});
      });
    }
  }

  // -------------------------
  // Boot
  // -------------------------
  function boot() {
  const qs = new URLSearchParams(location.search);

  // merge storage -> url (URL имеет приоритет)
  const saved = loadStateFromStorage();

  for (const [k, v] of Object.entries(saved)) {
    if (!qs.get(k)) {
      qs.set(k, v);
    }
  }

  // 🔥 ВАЖНО: единый источник make
  const presetMakeValue =
    window.CC_PRESET?.make ||
    qs.get("make"); // <-- FIX: было preset_make

  ensurePropertiesInForm();

  setupAddToCartObserver();

  syncProps();
  updateDotsAndProgress();
  wireUI();

  window.addEventListener("cc:set-change", (e) => {
    const set = e.detail;
    if (window.CAR_CONFIG_PRESET) {
      updatePrice(set);
    }
  });

  loadOptionsFor("make")
    .then(async () => {

      // авто-пресет (теперь единый и стабильный)
      if (presetMakeValue) {
        const applyPreset = () => {
          const items = document.querySelectorAll(
            ".cc-list[data-list='make'] .cc-item"
          );

          const target = Array.from(items).find(el =>
            el.textContent.trim().toLowerCase() ===
            presetMakeValue.trim().toLowerCase()
          );

          if (target) {
            target.click();
            return true;
          }
          return false;
        };

        if (!applyPreset()) {
          const interval = setInterval(() => {
            if (applyPreset()) clearInterval(interval);
          }, 150);

          setTimeout(() => clearInterval(interval), 10000);
        }
      }

      const first = firstIncompleteKey() || "make";
      const firstIndex = steps.findIndex((step) => step.key === first);

      await advanceFromStepIndex(firstIndex === -1 ? 0 : firstIndex);

    })
    .catch((err) => {
      console.error(err);
      setStatus("Błąd konfiguratora (sprawdź API).");
    });
}

  try {
    boot();
  } catch (err) {
    console.error(err);
    setStatus("Błąd konfiguratora (sprawdź API).");
  }
})();
